export interface ILogger<MessageType> {
  log(message: MessageType): void
  warn(message: MessageType): void
  error(error: Error | string): void
  success(message: MessageType): void
}

export class Logger<MessageType> implements ILogger<MessageType> {
  constructor(private readonly prefix: string = "") {}

  log(message: MessageType): void {
    console.log(this.prefix, message);
  }

  warn(message: MessageType): void {
    console.warn(this.prefix, message);
  }

  error(error: Error | string): void {
    console.error(this.prefix, error);
  }

  success(message: MessageType): void {
    console.log(`%c ${this.prefix} ${message} `, "color: green; font-weight: bold; background: white;");
  }
}

